import Forward16 from '@sats-group/icons/16/forward';
import Gym16 from '@sats-group/icons/16/gym';
import Location16 from '@sats-group/icons/16/location';
import Time16 from '@sats-group/icons/16/time';
import Link from '@sats-group/fresh-fitness-ui-lib/react/link';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';
import React from 'react';

import type { ClubLink as Props } from './club-link.types';

const ClubLink: React.FC<Props> = ({
  address,
  distance,
  href,
  name,
  openingHours,
  size,
  usp,
}) => (
  <Link className="club-link" href={href}>
    <div className="club-link__information">
      <Text
        className="club-link__name"
        elementName="span"
        size={Text.sizes.basic}
        theme={Text.themes.emphasis}
      >
        {name}
      </Text>
      {address ? (
        <span className="club-link__metadata">
          <Location16 />
          <Text elementName="span" size={Text.sizes.small}>
            {address}
          </Text>
        </span>
      ) : null}
      {distance ? (
        <span className="club-link__metadata">
          <Location16 />
          <Text elementName="span" size={Text.sizes.small}>
            {distance}
          </Text>
        </span>
      ) : null}
      {openingHours ? (
        <span className="club-link__metadata">
          <Time16 />
          <Text elementName="span" size={Text.sizes.small}>
            {openingHours}
          </Text>
        </span>
      ) : null}
      {size ? (
        <span className="club-link__metadata">
          <Gym16 />
          <Text elementName="span" size={Text.sizes.small}>
            {size}
          </Text>
        </span>
      ) : null}
      {usp ? (
        <span className="club-link__metadata">
          <span aria-hidden dangerouslySetInnerHTML={{ __html: usp.icon }} />
          <Text elementName="span" size={Text.sizes.small}>
            {usp.text}
          </Text>
        </span>
      ) : null}
    </div>
    <span aria-hidden className="club-link__forward">
      <Forward16 />
    </span>
  </Link>
);

export default ClubLink;
